import { apiService } from '../../../api'
import { GetCardScanResultRequest, GetCardScanResultRequestV2, GetCardScanResultResponse, GetCardScanSecretRequest, GetCardScanSecretResponse } from '../types'

const baseURL = '/portal/consumers/card-scan'

export const cardScanService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getBouncerSecret: build.query<GetCardScanSecretResponse, GetCardScanSecretRequest>({
      query: (data) => ({
        url: `${baseURL}/civ`,
        method: 'POST',
        data,
      }),
    }),
    getCardScanResult: build.query<GetCardScanResultResponse, GetCardScanResultRequest>({
      query: (data) => ({
        url: `${baseURL}/check`,
        method: 'POST',
        data,
      }),
    }),
    getCardScanResultV2: build.query<GetCardScanResultResponse, GetCardScanResultRequestV2>({
      query: (data) => ({
        url: `${baseURL}/check/v2`,
        method: 'POST',
        data,
      }),
    }),
  }),
})
